import got from '../../assets/work/got.png'
import got2 from '../../assets/work/got2.jpg'
import notebook from '../../assets/work/notebook.png'
import todo from '../../assets/work/todo.png'

const workObject = [
	{
		id: 1,
		image: got,
		name: 'GOT GraphQL',
		description:
			"GOTGraphQL is a GraphQL endpoint for the Game of Thrones API, generated from the JSON data. Game of Thrones is a popular TV show based on the book series 'A Song Of Ice And Fire' written by G.R.R.Martin",
		source: 'https://us-central1-gotapi-78e21.cloudfunctions.net/graphql/',
		github: 'https://github.com/vishalgautamm/graphQLofFireAndIce'
	},
	{
		id: 2,
		image: notebook,
		name: 'Notebook',
		description:
			'Notebook is a modern productivity tool that allows users to easily create and share meeting notes with others',
		source: 'https://github.com/vishalgautamm/notebook',
		github: 'https://github.com/vishalgautamm/notebook'
	},
	{
		id: 3,
		image: todo,
		name: 'To Do MVC',
		description: 'A To Do program written in Elm programming language',
		source: 'https://vishalgautamm.github.io/todoMVC/',
		github: 'https://github.com/vishalgautamm/todoMVC'
	}
]

export default workObject



// WEBPACK FOOTER //
// ./src/components/Work/workObject.js